import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@environment';
import { UtilityService } from '@core/services/util/utility.service';

@Injectable({
    providedIn: 'root'
})

export class FeedbackApiService {

    private apiUrl: string;

    constructor(
        private http: HttpClient,
        private utilityService: UtilityService,
    ) {
        this.apiUrl = environment.apiUrl;
    }

    create(orderTrackingId: any, details: any) {
        const headers = this.utilityService.getAuthHeaders('signed');
        const body = { ...details, channel: 'web' };
        return this.http.post(`${this.apiUrl}/order/${orderTrackingId}/order_feedbacks`, body, { headers });
    }

    // Open Method
    createOpen(orderTrackingId: any, details: any) {
        const body = { ...details, channel: 'web' };
        return this.http.post(`${this.apiUrl}/order/${orderTrackingId}/order_feedbacks/post_order_feedback`, body);
    }

    // Open Method
    getOrderDetails(orderId) {
        return this.http.get(`${this.apiUrl}/v2/order/${orderId}/order_feedbacks/get_order_feedback`);
    }

    getSignedUrl(size, type) {
        const headers = this.utilityService.getAuthHeaders('signed');
        return this.http.get(`${this.apiUrl}/v1/signed_url`, {
            params: {
                image_size: size,
                image_type: type
            },
            headers
        });
    }

    pushImageToS3(signedUrl, body) {
        const {type} = body;
        return this.http.put(signedUrl, body, {
            headers: {
                'Content-Type': type
            }
        });
    }
}